import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchPartnersSendingAdsProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchPartnersSendingAds = (filters: FetchPartnersSendingAdsProps) => void;

const fetchPartnersSendingAds = ({
  startDate,
  endDate,
  report
}: FetchPartnersSendingAdsProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {};
  await fetchReport(report, dispatch, params);
};

export default fetchPartnersSendingAds;
